import type { KeyboardEvent } from 'react';

/**
 * Invoke `action` when the user presses Enter or Space on a focusable element,
 * preventing the default scroll/submit behaviour. Kept dependency-free so the
 * nav package does not reach into any product-specific UI library.
 */
export function onKeyActivate(e: KeyboardEvent, action?: () => void): void {
  if (e.key === 'Enter' || e.key === ' ') {
    if (typeof e.preventDefault === 'function') {
      e.preventDefault();
    }
    action?.();
  }
}
